import { Stack } from '@mui/material';
import {
  ResourceType,
  RestoreJob,
  type BackupJob,
  type ScanJob,
} from '@repo/api-gw-sdk';

import { useEnvironment } from '@/contexts/useEnvironment';

import TemporalIcon from '../../../public/statics/images/apps/temporal.png';
import CopyToClipboardButton, {
  CopyToClipboardWrapper,
} from '../buttons/copyToClipboardButton';
import { CircleImage } from '../shared/circleImage';
import { TextLink } from '../shared/textLink';

export const TemporalLinkField = ({
  entity,
}: {
  entity: BackupJob | RestoreJob | ScanJob;
}) => {
  const { isDev } = useEnvironment();

  const getTemporalBaseUrl = () => {
    if (isDev) {
      return 'http://localhost:37670';
    }
    if (location.host.endsWith('testing-console.eon.io')) {
      return 'https://temporal.testing-infra.eon.io';
    }
    if (location.host.endsWith('console.app.eon.io')) {
      return 'https://temporal.prod-infra.app.eon.io';
    }
    return 'https://temporal.prod-infra.eon.io';
  };

  const getTemporalNamespace = () => {
    if (entity instanceof RestoreJob) {
      return 'restore';
    }

    if (entity.resourceDetails?.resourceType === ResourceType.AwsEc2) {
      return 'offlinescan';
    }
    return 'inventory';
  };

  return (
    <CopyToClipboardWrapper>
      <Stack direction='row' alignItems='center' gap='8px'>
        <CircleImage src={TemporalIcon} alt='temporal' />
        <TextLink
          target='_blank'
          href={`${getTemporalBaseUrl()}/namespaces/${getTemporalNamespace()}/workflows/${entity.jobExecutionDetails.jobId}`}
        >
          {entity.jobExecutionDetails.jobId}
        </TextLink>
        <CopyToClipboardButton
          textToCopy={entity.jobExecutionDetails.jobId}
          showOnlyOnHover
          size='small'
        />
      </Stack>
    </CopyToClipboardWrapper>
  );
};
